import i18nConfig from '@/config/i18n'

const { countries, locales, defaultCountry, defaultLocale } = i18nConfig

export default () => ({
  countries,
  countriesData: {},
  country: defaultCountry,
  defaultCountry,
  locales,
  locale: defaultLocale,
  backButton: {
    visible: false,
    text: null,
    to: null
    // This click function is removed from the initialState to prevent the "Cannot stringify a function click" Warning on SSR
    // click: () => {}
  }
})
